import ChainSvg from "../../assets/landing/icons/ecosystem-icon/ChainSvg";

import {
  AboutIconSvg,
  CommunityIconSvg,
  EcosystemIconSvg,
} from "../../assets/landing/icons/navigation-icons";

import {
  DiscordSvg,
  MediumSvg,
  TelegramSvg,
  TwitterSvg,
} from "../../assets/landing/icons/social";

import {
  PrivySvg,
  BaseSvg,
  SolanaSvg,
  InkSvg,
  LayerZeroSvg,
  RaydiumSvg,
  KodiakSvg,
  AerodromeSvg,
  AethirSvg,
  MonadSvg,
} from "../../assets/landing/icons/partners-icons";

import {
  ProjectIconSvg,
  UserIconSvg,
} from "../../assets/landing/icons/join-icons";

import {
  BuildSvg,
  leftBotCardSvg,
  leftTopCardSvg,
  topBotCardSvg,
  topRightCardSvg,
  rightBottomCard,
} from "../../assets/landing/icons/ecosystem-icon";
import AgntRegistrationIcon from "assets/landing/icons/burger-icons/AgntRegistrationIcon";
import AgntGymIcon from "assets/landing/icons/burger-icons/AgntGymIcon";
import AgntAmbassadorIcon from "assets/landing/icons/burger-icons/AgntAmbassadorIcon";
import AGNTDocsIcon from "assets/landing/icons/burger-icons/AGNTDocsIcon";
import AgntConnectIcon from "assets/landing/icons/burger-icons/AgntConnectIcon";
import LaunchIcon from "assets/landing/icons/ecosystem-icon/LaunchIcon";
import Neo3Icon from "assets/landing/icons/ecosystem-icon/Neo3Icon";
import BNBChain from "assets/landing/icons/partners-icons/BNBChain";
import Pancake from "assets/landing/icons/partners-icons/Pancake";
import Alchemy from "assets/landing/icons/partners-icons/Alchemy";
import OpenOcean from "assets/landing/icons/partners-icons/OpenOcean";
import FetchAi from "assets/landing/icons/partners-icons/FetchAi";
import AltLayer from "assets/landing/icons/partners-icons/AltLayer";
import OpenGradient from "assets/landing/icons/partners-icons/OpenGradient";
import Elsa from "assets/landing/icons/partners-icons/Elsa";
import Jupiter from "assets/landing/icons/partners-icons/Jupiter";
import Limitless from "assets/landing/icons/partners-icons/Limitless";
import AgntMobileIcon from "assets/landing/icons/burger-icons/AgntMobileIcon";
import CardPlusIcon from "assets/landing/icons/CardPlusIcon";

export const navigationLinks = [
  {
    id: 1,
    name: "Ecosystem",
    url: "#",
    icon: EcosystemIconSvg,
  },
  {
    id: 2,
    name: "Community",
    url: "#",
    icon: CommunityIconSvg,
  },
  {
    id: 3,
    name: "About",
    url: "#",
    icon: AboutIconSvg,
  },
];

export const socialItems = [
  {
    id: 1,
    linkUrl: "https://blog.agnthub.ai/",
    icon: MediumSvg,
  },
  {
    id: 2,
    linkUrl: "https://x.com/agnt_hub",
    icon: TwitterSvg,
  },
  {
    id: 3,
    linkUrl: "https://t.me/agnt_ann",
    icon: TelegramSvg,
  },
  {
    id: 4,
    linkUrl: "https://discord.gg/agnthub",
    icon: DiscordSvg,
  },

  //COMING SOON
  // {
  //   id: 5,
  //   linkUrl: "#",
  //   icon: GitbookSvg,
  // },
];

export const partnersIcons = [
  {
    id: "Blast",
    icon: <BNBChain />,
  },
  {
    id: "Evmos",
    icon: <AethirSvg className="!rotate-[4deg]" />,
  },
  {
    id: "Base",
    icon: <Pancake className="!rotate-[-1deg]" />,
  },
  {
    id: "Privy",
    icon: <PrivySvg className="!rotate-[4deg]" />,
  },
  {
    id: "LayerZeroSvg",
    icon: <LayerZeroSvg className="!rotate-[4deg]" />,
  },

  {
    id: "Alchemy",
    icon: <Alchemy className="!rotate-[-1deg]" />,
  },

  {
    id: "OpenOcean",
    icon: <OpenOcean />,
  },
  {
    id: "FetchAi",
    icon: <FetchAi />,
  },

  {
    id: "AltLayer",
    icon: <AltLayer />,
  },

  {
    id: "OpenGradient",
    icon: <OpenGradient />,
  },
  {
    id: "Elsa",
    icon: <Elsa />,
  },
  {
    id: "Jupiter",
    icon: <Jupiter />,
  },
  {
    id: "Limitless",
    icon: <Limitless />,
  },
];

export const joinItems = [
  {
    title: "For Users",
    information: [
      "Access onchain actions directly in your X feed with one click.",
      "Use AGNT Mobile to run X Mini Apps and manage your flow on the go.",
      "Get global payments with Neo3 cards",
    ],
    linkName: "Preregister Now",
    icon: UserIconSvg,
    isBlueLine: true,
    url: "https://join.agnthub.ai",
  },
  {
    title: "For Projects",
    information: [
      "Build and launch X Mini Apps with no heavy front-end work.",
      "Run SocialFi & InfoFi campaigns natively in the feed.",
      "Keep users returning with native retention loops inside X.",
    ],
    linkName: "Launch with AGNT",
    icon: ProjectIconSvg,
    url: "https://chromewebstore.google.com/detail/agntconnect/lgdfffagihonfnkcffpikpifhegcdkge?utm_source=item-share-cb",
  },
];

export const navigationFooterLinks = [
  {
    id: 1,
    title: "Ecosystem",
    items: [
      {
        name: "AGNT Connect",
        url: "https://go.agnthub.ai/connect",
      },
      {
        name: "AGNT Mobile",
        url: "#",
      },
    ],
  },
  {
    id: 2,
    title: "Community",
    items: [
      {
        name: "Registration",
        url: "https://join.agnthub.ai",
      },
      {
        name: "AGNT Gym",
        url: "https://quests.agnthub.ai",
      },
      {
        name: "Ambassador program",
        url: "#",
      },
    ],
  },
  {
    id: 3,
    title: "About",
    items: [
      {
        name: "Docs",
        url: "#",
      },
    ],
  },
];

export const ecosystemItems = [
  {
    step: "Install AGNT Connect",
    stepIcon: (
      <ChainSvg className="w-[2.01vw] h-[2.5vw] max-lg:w-[7.73vw] max-lg:h-[9.6vw]" />
    ),
    title: "AGNT Connect",
    desc: "A browser extension that embeds Web3 execution, analytics, SocialFi and InfoFi campaigns directly into the X interface.",
    itemCardImg: leftTopCardSvg,
    descWidth: 26.541,
  },

  {
    step: "Launch AGNT Mobile",
    stepIcon: (
      <LaunchIcon className="w-[1.8vw] h-[2.22vw] max-lg:w-[6.93vw] max-lg:h-[8.53vw]" />
    ),
    title: "AGNT Mobile",
    desc: "A progressive web app that mirrors AGNT Connect on mobile. Hosts X Mini Apps and integrates AGNT Neo3 cards for payments.",
    itemCardImg: topRightCardSvg,
    descWidth: 26.285,
  },
  {
    step: "Get AGNT Neo3 Card",
    stepIcon: (
      <Neo3Icon className="w-[2.5vw] h-[2.01vw] max-lg:w-[9.6vw] max-lg:h-[7.73vw]" />
    ),
    title: "AGNT Neo3 Bank & Cards",
    desc: "Financial Layer inside AGNT Mobile. Open a card without KYC and pay anywhere, powered by AGNT Neo3 rails.",
    itemCardImg: leftBotCardSvg,
    descWidth: 26.541,
  },

  {
    step: "Build with AGNT Studio",
    stepIcon: (
      <BuildSvg className="w-[2.5vw] h-[2.01vw] max-lg:w-[9.6vw] max-lg:h-[7.73vw]" />
    ),
    title: "AGNT X App Studio",
    desc: "The builder layer for protocols. Launch and run X Mini Apps natively without heavy custom front-ends.",
    itemCardImg: rightBottomCard,
    descWidth: 26.285,
  },
];

export const attentionsItem = [
  {
    id: 11,
    title: "Protocol launch \n with AGNT Hub",
    items: ["Embedded Interfaces", "SocialFi Launcher", "InfoFi Launcher"],
  },
  {
    id: 12,
    title: "Users engage \n via AGNT Connect / Mobile",
    items: [
      "Advanced web3 analytics in X",
      "Onchain / Offchain actions ",
      "Crypto X Feed",
    ],
  },
  {
    id: 13,
    title: "Expansion with \n AGNT Neo3",
    items:
      "Global cards and payments without KYC, embedded right into AGNT Mobile",
  },
  {
    id: 14,
    title: "Retention inside \n X Mini Apps",
    items:
      "Native loops that remember user progress and keep them coming back.",
  },
];

export const attentionsItemMob = [
  {
    id: 15,
    title: "Protocol launch \n with AGNT Hub",
    items: ["Embedded Interfaces", "SocialFi Launcher", "InfoFi Launcher"],
  },
  {
    id: 16,
    title: "Users engage \n via AGNT Connect / Mobile",
    items: [
      "Advanced web3 analytics in X",
      "Onchain / Offchain actions ",
      "Crypto X Feed",
    ],
  },
  {
    id: 17,
    title: "Expansion with \n AGNT Neo3",
    items:
      "Global cards and payments without KYC, embedded right into AGNT Mobile",
  },
  {
    id: 18,
    title: "Retention inside \n X Mini Apps",
    items:
      "Native loops that remember user progress and keep them coming back.",
  },
];

export const ecosystemDropDownIcons = [
  {
    id: 1,
    name: "AGNT Connect",
    isBlank: true,
    url: "https://go.agnthub.ai/connect",
    icon: AgntConnectIcon,
  },
  {
    id: 2,
    name: "AGNT mobile",
    isBlank: true,
    url: "#",
    icon: AgntMobileIcon,
  },
  {
    id: 3,
    name: "Card",
    isBlank: false,
    url: "/card",
    icon: CardPlusIcon,
  },
];

export const communityItems = [
  {
    icon: AgntRegistrationIcon,
    name: "Registration",
    url: "https://join.agnthub.ai",
  },
  {
    icon: AgntGymIcon,
    name: "AGNT Gym",
    url: "https://quests.agnthub.ai",
  },
  {
    icon: AgntAmbassadorIcon,
    name: "Ambassador program",
    url: "#",
  },
];

export const aboutItems = [
  {
    icon: AGNTDocsIcon,
    name: "Docs",
    url: "#",
  },
];
